export interface ApplyForPaymentsResponse {
  applicationId?: string;
  webKybUrl?: string;
  merchantId: string;
  storeId: string;
}